import { TOGGLE_AUDIO } from '../constants/actions';

export default function toggleAudio(bool) {
  return {
    type: TOGGLE_AUDIO,
    payload: bool
  };
}



/** WEBPACK FOOTER **
 ** ./src/js/actions/audio.js
 **/